import store from '@/store';
import parser from 'cron-parser';


export class Task {
	constructor (timePolicy, name, runFunction, description){
		this.name = name;
		this.description = description;
		this.timePolicy = timePolicy;
		this.runFunction = runFunction;
		
		this.lastRunTime = window.localStorage.getItem('Task-'+name) || new Date('2020-01-01');
		this.futureRunTime = null;
		this.setFuturRunTime();
	}
	
	setFuturRunTime() {
        let interval = parser.parseExpression(this.timePolicy,{currentDate:this.lastRunTime});
        this.futureRunTime = interval.next().getTime();

	}

    async run(){
        if(typeof(this.runFunction) != 'function'){
            console.error('Fonction de la tache manquante');
            return false;
        }

        //test si il faut lancer
        let now = new Date().getTime();
        if(this.futureRunTime < now){
        	window.localStorage.setItem('Task-'+this.name, new Date());
            //on actualise date dernier lancement avant l'attente : deux ticks
            //rapproches ne doivent pas relancer la meme tache
            this.lastRunTime = now;
            this.setFuturRunTime();
            await this.runFunction();
        }

    }

}



export class TaskWorker {
	
	constructor(intervalTime) {
		if (!intervalTime){
			intervalTime = 1000*60;
		}
		this.intervalTime = intervalTime; // en milliseconde
		this.isRun = false;
		this.tasks = [];
		console.log('TaskWorker');
	}
	
	init() {
		this.initTask();
		setInterval(this.makeTasksList.bind(this), this.intervalTime);
	}
	
	initTask(){
		this.tasks.push(new Task("*/10 * * * *", "checkConfig", this.checkConfig.bind(this)));
		this.tasks.push(new Task("*/2 * * * *", "sync", this.sync.bind(this)));
		this.tasks.push(new Task("0 1 * * *", "removeSyncPictures", this.removeSyncPictures.bind(this)));
	}
	
	async checkConfig(){
		await store.dispatch('config/refresh');
	}
	
	async removeSyncPictures(){
		let evtids = store.getters['events/getAllUid'];
		await store.dispatch('pictures/removeSynced', evtids);
		await store.dispatch('interventions/removeSynced', evtids);
	}
	
	async sync() {
		// avant d'envoyer : remettre en attente les photos declarees dans un
		// formulaire et jamais confirmees, meme si la mission est deja marquee
		// synchronisee. C'est ce rattrapage qui fait repartir les photos d'une
		// synchro interrompue sans action de l'utilisateur.
		await store.dispatch('interventions/checkAllPictures');
		await store.dispatch('pictures/sync');
		await store.dispatch('interventions/pushAll');
		// apres envoi : reevaluer ce qui reste en attente, une mission n'est
		// entierement synchronisee que si toutes ses photos sont confirmees
		await store.dispatch('interventions/checkAllPictures');
	}

	// sync() est appelee par le tick cron (via Task) et directement au retour au
	// premier plan : sans ce verrou partage les deux se chevauchent sur les memes
	// photos et produisent un doublon cote eKo
	async runSync() {
		if (this.isRunning()) {
			return false;
		}
		this.setRunning();
		try {
			await this.sync();
		} finally {
			this.setNotRunning();
		}
	}
	
    setRunning(){
        this.isRun = true;
    }

    setNotRunning(){
        this.isRun = false;
    }

    isRunning(){
        return this.isRun;
    }

    makeTasksList(){
        //on test si ca ne tourne pas déja(lancement manuel)
        if(this.isRunning()){
            return false;
        }

        //lancement en cours
        this.setRunning();
        return this.runTasks();
    }

    async runTasks(){
        try {
            for (const task of this.tasks) {
                //une tache qui echoue ne doit pas empecher les suivantes :
                //le forEach d'origine les isolait, l'attente sequentielle non
                try {
                    await task.run();
                } catch (e) {
                    console.log('Error task', task.name, e);
                }
            }
        } finally {
            //tache terminé
            this.setNotRunning();
        }
    }

	
}